export const resetPageScroll = () => {
  const mainBody = document.querySelector(".main-body");
  mainBody.scrollTop = 0;
};
